export default {
  title: 'Torre de Control',

  // Estados de pantalla
  idle_title: 'No has realizado búsquedas',
  idle_subtitle: 'Aquí podrás visualizar las Tareas que se han asignado',
  idle_action: 'Buscar tareas',
  loading_title: 'Cargando los resultados...',
  loading_subtitle: 'Estamos armando tu tablero.',
  empty_title: 'Sin resultados',
  empty_subtitle: 'Ninguna tarea coincide con los filtros aplicados.',
  empty_action: 'Limpiar filtros',
  error_title: 'No pudimos cargar el tablero',
  error_subtitle: 'Vuelve a intentarlo. Si sigue fallando, avísale al equipo.',
  error_action: 'Reintentar',

  // Barra de herramientas
  select_many: 'Seleccionar varias',
  download: 'Descargar',
  new_task: 'Nueva Tarea',
  view_kanban: 'Vista de tablero',
  view_list: 'Vista de lista',
  edit_columns: 'Personalizar columnas',
  edit: 'Editar',
  reassign: 'Reasignar',
  delete: 'Eliminar',

  // Catálogos de filtro (el texto visible siempre sale de aquí)
  origin_form: 'Formularios',
  origin_task: 'Tareas',
  origin_quick_review: 'Revisiones rápidas',
  origin_sprint: 'Sprints',
  origin_resource: 'Recursos',
  origin_routine: 'Rutinas',
  priority_low: 'Baja',
  priority_medium: 'Media',
  priority_high: 'Alta',
  sort_end_date: 'Fecha límite',
  sort_title: 'Título',

  // Columnas de la vista de lista
  column_state: 'Estatus',
  column_title: 'Título',
  column_origin: 'Origen',
  column_evidences: 'Evidencias',
  column_assignee: 'Responsable',
  column_location: 'Ubicación',
  column_end_date: 'Fecha Límite',
  column_priority: 'Prioridad',
  column_region: 'Región',
  column_zone: 'Zona',
  column_district: 'Distrito',
  column_created_by: 'Creada por',
  column_tag: 'Categoría',
  column_tag2: 'Área',

  // Filtros
  filter: 'FILTRO',
  filter_type: 'Tipo de Filtrado',
  by_status: 'Por Estatus',
  by_user: 'Por Usuario',
  by_location: 'Por Ubicación',
  my_filters: 'Mis Filtros',
  filter_name: 'Nombre del filtro',
  save_filter: 'Guardar filtro',
  save_filter_confirm: '¿Guardar este filtro?',
  overwrite_filter_confirm: 'Ya existe un filtro con ese nombre. Si lo reescribes no podrás recuperar el anterior.',
  rename_filter: 'Editar nombre',
  delete_filter: 'Eliminar filtro',
  clear_filters: 'Eliminar filtro',
  apply: 'Aplicar',
  responsible: 'Responsable',
  search_responsible: 'Buscar un responsable',
  location: 'Ubicación',
  search_location: 'Buscar una ubicación',
  priority: 'Prioridad',
  tag: 'Etiqueta',
  origin: 'Origen',
  status: 'Estatus',
  period: 'Periodo',
  start_date: 'Desde',
  end_date: 'Hasta',
  sort: 'Ordenar',
  sort_add: 'Agregar',
  category: 'Categoría',
  area: 'Área',
  search: 'Buscar',
  you: '(Yo)',

  // Columnas del tablero
  pin_status: 'Fijar Estatus',
  pin_user: 'Fijar Usuario',
  pin_location: 'Fijar Ubicación',
  send_to_end: 'Mandar al final',
  swap_with: 'Intercambiar lugar con…',
  columns_prev: 'Columnas anteriores',
  columns_next: 'Columnas siguientes',
  column_menu: 'Menú de la columna',
  change_state: 'Cambiar estatus',
  task_state_in_progress: 'En proceso',
  task_state_overdue: 'Vencida',
  task_state_suspended: 'Suspendida',
  task_state_finished: 'Finalizada',
  toast_move_failed: 'No se pudo mover la tarea',
  totals: 'Totales',
  overdue: 'Vencidas',
  in_progress: 'En proceso',
  finished: 'Finalizadas',
  suspended: 'Suspendidas',
  escalated: 'Escaladas',
  load_more: 'Cargar más',

  // Tarjeta
  evidences: 'Evidencias',
  evidences_count: '{count} Evidencias',

  // Acciones masivas
  delete_dialog_title: '¿Desea eliminar estas tareas?',
  delete_dialog_text: 'Una vez eliminadas no podrá recuperarlas.',
  delete_confirm: 'Eliminar',
  cancel: 'Cancelar',
  reassign_dialog_title: '¿A quién quieres reasignar estas tareas?',
  reassign_dialog_text: 'Se enviarán estas tareas al usuario seleccionado.',
  reassign_confirm: 'Reasignar',
  reassign_cross_location: 'Este usuario cuenta con una ubicación diferente, favor de reasignar a un usuario con la misma ubicación.',
  edit_dialog_title: 'Selecciona un elemento para editar.',
  edit_dialog_text: 'Se editará la siguiente información en todas las tareas seleccionadas.',
  edit_field: 'Selecciona...',
  edit_value: 'Selecciona...',
  field_priority: 'Prioridad',
  field_assignee: 'Responsable',
  field_state: 'Estatus',
  field_evidence: 'Foto obligatoria',
  field_tags: 'Etiquetas',
  evidence_required: 'Requerir foto',
  evidence_not_required: 'No se requiere foto',
  save_changes: 'Guardar cambios',
  save: 'Guardar',

  // Descargas
  download_pdf: 'PDF',
  download_excel: 'Excel (.xlsx)',
  download_csv: '.csv',
  columns_dialog_title: 'Selecciona los elementos para incluir en tu tabla',
  columns_dialog_select: 'Personalizar las columnas',
  download_full_table: 'Descargar tabla completa',
  document_dialog_title: 'Selecciona los elementos para incluir dentro de tu documento',
  default_view: 'Ver la vista predeterminada',

  // Reporte
  report_title: 'Reporte de Torre de Control',
  report_compliance: 'Cumplimiento de Tareas',
  report_filters: 'Filtros aplicados',
  report_users: 'Usuarios',
  report_filters_detailed: 'Filtros detallados',
  report_created_with: 'Creado con',
  report_date_of: 'Fecha de',
  report_date_to: 'a',
  report_date: 'Fecha',
  report_location: 'Ubicación',
  report_evidences: '{count} evidencias',
  report_evidences_one: '1 evidencia',
  report_empty_group: 'Sin tareas en este grupo',
  report_no_data: 'Sin tareas para graficar',

  // Avisos
  toast_pinned: 'Columna fijada al inicio',
  toast_pinned_status: 'Estatus fijado con éxito.',
  toast_pinned_user: 'Usuario fijado con éxito.',
  toast_pinned_location: 'Ubicación fijada con éxito.',
  toast_sent_to_end: 'Columna enviada al final',
  toast_swapped: 'Columnas intercambiadas',
  toast_task_created: 'Tarea creada con éxito.',
  toast_deleted: 'Tareas eliminadas con éxito.',
  toast_reassigned: 'Reasignación realizada con éxito',
  toast_updated: 'Se han guardado los cambios con éxito',
  toast_filter_saved: 'Filtro guardado con éxito',
  toast_downloaded: 'Descarga realizada con éxito.',
  toast_columns_saved: 'Columnas actualizadas',

  // Detalle y alta de tarea
  detail_conversation: 'Conversación',
  detail_read_only: 'Sólo lectura',
  detail_assigned_by: 'Asignado por',
  detail_photo_required: '*Requiere fotografía',
  detail_no_comments: 'Todavía no hay mensajes en esta tarea.',
  detail_write_comment: 'Escribe un comentario',
  send: 'Enviar',
  detail_comment_error: 'No se pudo guardar el comentario.',
  detail_comment_closed: 'La tarea está cerrada: ya no admite comentarios.',
  detail_reassigned_to: 'Reasignada a {user}',
  create: 'Crear',
  field_title: 'Título',
  field_description: 'Descripción...',
  field_photo: 'Foto',
  field_due_date: 'Fecha Límite',
  field_assignees: 'Responsables (máx. {max})',
  field_readers_toggle: 'Agregar Lector',
  field_users_placeholder: 'Usuario(s)',
  location_selected_single: 'Se ha seleccionado {name} como Ubicación. Haz click aquí para cambiar la ubicación.',
  date_placeholder: '----/----/--------',
  field_readers: 'Lectores (máx. {max})',
  max_assignees: 'Máximo {max} responsables',
  max_readers: 'Máximo {max} lectores',
  approval_notice: 'Al finalizarse, esta tarea requerirá la aprobación de quien la creó.',
  toast_task_created_many: '{count} tareas creadas con éxito',
  detail_task: 'Tarea',
  detail_origin: 'Origen:',
  detail_tags: 'Etiquetas',
  detail_see_more: 'Ver más',

  // Nueva tarea
  new_task_single: 'Una tarea',
  new_task_multiple: 'Múltiples ubicaciones',

  // Nueva tarea (diseño Figma) y avisos de los diálogos (Bloque D)
  field_title_placeholder: 'Título de la tarea...',
  field_require_photo: 'Requerir fotografía',
  field_responsible: 'Selecciona un responsable',
  locations_title: 'Ubicaciones',
  locations_none: 'No se ha seleccionado una ubicación.',
  locations_selected: '{count} ubicación(es) seleccionada(s)',
  accept: 'Aceptar',
  reassign_error_title: 'No se puede reasignar a este usuario.',
  close_notice: 'Cerrar',
  reassign_error_generic: 'No se pudo completar la acción. Inténtalo de nuevo.',
  edit_error_title: 'No se pudieron guardar los cambios',
  list_focus_empty: 'No hay tareas con este indicador.',

  // Panel de filtros (Bloque C)
  filter_all: 'Todos',
  filter_no_options: 'Sin resultados',
  clear_selection: 'Quitar selección',
  tags: 'Etiquetas',
  site: 'Sitio',
  subcategory: 'Subcategoría',
  date: 'Fecha',
  search_origin: 'Buscar un origen',
  clear_all_filters: 'Borrar todos los filtros',
  show_tasks: 'Mostrar Tareas',
  confirm_name: 'Guardar nombre',
  preset: 'Filtro',
  apply_preset: 'Aplicar este filtro',
  save_preset: 'Guardar filtros en este espacio',
  preset_needs_filters: 'Primero selecciona los filtros que quieres guardar.',
  preset_name_taken: 'Ya tienes un filtro con ese nombre.',
  preset_save_error: 'No se pudo guardar el filtro. Inténtalo de nuevo.',
  save_preset_title: '¿Quieres guardar este filtro?',
  save_preset_text: 'En este espacio se guardarán los datos llenados del filtro.',
  overwrite_title: '¿Deseas reescribir este filtro?',
  overwrite_text: 'Al guardar un nuevo filtro, se borrará el anterior y no se podrá recuperar.',
  delete_preset_title: '¿Deseas eliminar este filtro?',
  delete_preset_text: 'Una vez eliminado no podrás recuperarlo.',
  sort_title_dialog: 'Selecciona el ordenamiento',
  sort_by: 'Ordenar por:',
  sort_confirm: 'Ordenar',
  sort_asc: 'Ascendente',
  sort_desc: 'Descendente',
  sort_remove: 'Quitar este orden',
  sort_add_filter: 'Agregar filtro',
  sort_delete_filter: 'Eliminar filtro',
  date_start: 'Inicio',
  date_end: 'Final',
  origin_of_task: 'Origen de Tarea',
  select_option: 'Selecciona',
  close: 'Cerrar',
  results_with_filters: 'Resultados de tu búsqueda con Filtros'
}
